import { render, staticRenderFns } from "./CustomerShowTreatment.vue?vue&type=template&id=b7d91a74"
import script from "./CustomerShowTreatment.vue?vue&type=script&lang=js"
export * from "./CustomerShowTreatment.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowTreatment.vue?vue&type=style&index=0&id=b7d91a74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports